var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.disabled?'batch-operate-item batch-operate-item--disabled':'batch-operate-item',on:{"click":_vm.onClick}},[_c('div',{staticClass:"batch-operate-item__icon"},[_vm._t("icon")],2),_c('div',{staticClass:"batch-operate-item__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }